import React from 'react';
import { Link } from 'react-router-dom';
import './Events.scss';

const Events = () => {
  const upcomingEvents = [
    {
      id: 1,
      icon: '🎤',
      type: 'Live Event',
      title: 'Open Mic Night',
      tagline: "Let's Mic Together",
      description: 'Join us for a night of creativity, connection, and community at Crave Café.',
      date: 'January 27',
      activities: 'Music • Poetry • Comedy • Spoken Word',
      location: 'Crave Café – Studio City',
      details: 'All are welcome — whether you\'re stepping up to the mic or just enjoying the vibe. Come support local voices, meet new people, and be part of an unforgettable evening.',
      featured: true
    }
  ];

  return (
    <main className="events-page" aria-label="Events at Crave Café">
      {/* Hero Section */}
      <section className="events-hero">
        <div className="events-hero__bg-pattern"></div>
        <div className="events-hero__content">
          <h1 className="events-hero__title">Events at Crave Café</h1>
          <p className="events-hero__subtitle">Where the Community Comes Together</p>
          <div className="events-hero__divider"></div>
          <p className="events-hero__description">
            Crave Café is more than a place to eat — it's a place to connect. 
            From community nights to live performances, our events are designed 
            to bring people together over great food, coffee, and conversation.
          </p>
        </div>
      </section>

      {/* Events List Section */}
      <section className="events-list" aria-label="Upcoming Events">
        <div className="events-list__container">
          <h2 className="events-list__heading">Upcoming Events</h2>
          
          <div className="events-grid">
            {upcomingEvents.map((event) => (
              <article 
                key={event.id} 
                className={`event-card ${event.featured ? 'event-card--featured' : ''}`}
              >
                <div className="event-card__content">
                  <div className="event-card__badge">
                    <span className="event-card__badge-icon">{event.icon}</span>
                    <span className="event-card__badge-label">{event.type}</span>
                  </div>
                  
                  <h3 className="event-card__title">{event.title}</h3>
                  <p className="event-card__tagline">{event.tagline}</p>
                  
                  <p className="event-card__description">{event.description}</p>
                  
                  <div className="event-card__details">
                    <div className="event-card__detail">
                      <div className="event-card__detail-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                      </div>
                      <div className="event-card__detail-text">
                        <span className="event-card__detail-label">Date</span>
                        <span className="event-card__detail-value">{event.date}</span>
                      </div>
                    </div>
                    
                    <div className="event-card__detail">
                      <div className="event-card__detail-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M9 18V5l12-2v13"/>
                          <circle cx="6" cy="18" r="3"/>
                          <circle cx="18" cy="16" r="3"/>
                        </svg>
                      </div>
                      <div className="event-card__detail-text">
                        <span className="event-card__detail-label">Performances</span>
                        <span className="event-card__detail-value">{event.activities}</span>
                      </div>
                    </div>
                    
                    <div className="event-card__detail">
                      <div className="event-card__detail-icon">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                          <circle cx="12" cy="10" r="3"/>
                        </svg>
                      </div>
                      <div className="event-card__detail-text">
                        <span className="event-card__detail-label">Location</span>
                        <span className="event-card__detail-value">{event.location}</span>
                      </div>
                    </div>
                  </div>
                  
                  <p className="event-card__footer">{event.details}</p>
                </div>
              </article>
            ))}
          </div>

          {/* Call to Action */}
          <div className="events-cta">
            <p className="events-cta__text">Hungry? Order ahead and pick up before the show!</p>
            <Link to="/order" className="events-cta__button">
              <span>Order Online</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Events;
